import { IconSprite } from "../../../../ui/IconSprite/IconSprite";

import { Button } from "./MenuButton.styled";

export const MenuButton = ({ isOpen, handler }) => (
  <Button aria-label="menu" onClick={handler}>
    <IconSprite width="16" height="16" tag={!isOpen ? "menu" : "close"} />
  </Button>
);
